import { render } from "./RecordInsightsDrawer.vue?vue&type=template&id=3ee9edf0&scoped=true"
import script from "./RecordInsightsDrawer.vue?vue&type=script&lang=js"
export * from "./RecordInsightsDrawer.vue?vue&type=script&lang=js"

import "./RecordInsightsDrawer.vue?vue&type=style&index=0&id=3ee9edf0&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee9edf0"]])

export default __exports__